export enum ProcessType {
    NONE,
    TASK,
    JOB,
    MULTI_STEP_JOB
}
